<div class="app-l-mc__sidepanel-wrap" [ngClass]="cssClass" role="dialog" aria-modal="true" aria-labelledby="user-event-assign-title">
    <div class="app-l-mc__head">
        <div class="userevent-head">
            <label id="user-event-assign-title" translate>eventAssign.selectOptionToAssign</label>
            <button  #closeButton
                type="button"
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                (click)="cancel()" (keypress)="cancel()" aria-label="Close assign dialog">
                <svg-icon icon="modal-close-button" class="w-100 h-100" aria-hidden="true"></svg-icon>
            </button>
        </div>
    </div>

    <div class="app-l-mc__body">

        <!-- Assignee -->
        <label class="required" translate>eventAssign.assignee</label>
        <div class="custom-form-field">
            <div class="app-c-custom-select" [class.is-open]="isUserOpen">
                <div class="app-c-select-trigger app-c-form-control"
                    [class.disabled]="disableUserList"
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isUserOpen"
                    [attr.aria-haspopup]="'listbox'"
                    [attr.aria-label]="selectedUser ? 'Selected assignee: ' + (selectedUser.fullName || selectedUser.Name) : 'Select assignee'"
                    (click)="!disableUserList && (isUserOpen = !isUserOpen); $event.stopPropagation()"
                    (keydown.enter)="!disableUserList && (isUserOpen = !isUserOpen); $event.stopPropagation()"
                    (keydown.space)="!disableUserList && (isUserOpen = !isUserOpen); $event.stopPropagation()">
                    <span [class.placeholder]="!selectedUser">
                        {{ selectedUser ? (selectedUser.fullName || selectedUser.Name) : ('eventAssign.chooseFromList' | translate) }}
                    </span>
                </div>
                <ul class="app-c-select-list" *ngIf="isUserOpen && !disableUserList" role="listbox" aria-label="Assignee list" (click)="$event.stopPropagation()">
                    <ng-container *ngFor="let user of userList">
                        <li *ngIf="user.Synched"
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="selectedUser === user"
                            [class.is-selected]="selectedUser === user"
                            (click)="selectedUser = user; isUserOpen = false; onUserChange()"
                            (keydown.enter)="selectedUser = user; isUserOpen = false; onUserChange()"
                            (keydown.space)="selectedUser = user; isUserOpen = false; onUserChange()">
                            {{ user.fullName || user.Name }}
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>

        <!-- Select Event Type -->
        <label class="required" translate>eventAssign.selectEventType</label>
        <div class="custom-form-field">
            <div class="app-c-custom-select" [class.is-open]="isEventTypeOpen">
                <div class="app-c-select-trigger app-c-form-control"
                    [class.disabled]="disableEventList"
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isEventTypeOpen"
                    [attr.aria-haspopup]="'listbox'"
                    [attr.aria-label]="selectedEventType ? 'Selected event type: ' + (selectedEventType.name | translate) : 'Select event type'"
                    (click)="!disableEventList && (isEventTypeOpen = !isEventTypeOpen); $event.stopPropagation()"
                    (keydown.enter)="!disableEventList && (isEventTypeOpen = !isEventTypeOpen); $event.stopPropagation()"
                    (keydown.space)="!disableEventList && (isEventTypeOpen = !isEventTypeOpen); $event.stopPropagation()">
                    <span [class.placeholder]="!selectedEventType">
                        {{ selectedEventType ? (selectedEventType.name | translate) : ('eventAssign.chooseFromList' | translate) }}
                    </span>
                </div>
                <ul class="app-c-select-list" *ngIf="isEventTypeOpen && !disableEventList" role="listbox" aria-label="Event type list" (click)="$event.stopPropagation()">
                    <li *ngFor="let event of eventTypeList"
                        role="option"
                        tabindex="0"
                        [attr.aria-selected]="selectedEventType === event"
                        [class.is-selected]="selectedEventType === event"
                        (click)="selectedEventType = event; isEventTypeOpen = false; onChangeEventType()"
                        (keydown.enter)="selectedEventType = event; isEventTypeOpen = false; onChangeEventType()"
                        (keydown.space)="selectedEventType = event; isEventTypeOpen = false; onChangeEventType()">
                        {{ event.name | translate }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Select Series Type -->
        <ng-container *ngIf="showSeriesType && selectedEventType?.subType?.length">
            <label class="required" translate>eventAssign.selectSeriesType</label>
            <div class="custom-form-field">
                <div class="app-c-custom-select" [class.is-open]="isSeriesTypeOpen">
                    <div class="app-c-select-trigger app-c-form-control"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="isSeriesTypeOpen"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-label]="selectedEventSeriesType ? 'Selected series type: ' + (selectedEventSeriesType.name | translate) : 'Select series type'"
                        (click)="isSeriesTypeOpen = !isSeriesTypeOpen; $event.stopPropagation()"
                        (keydown.enter)="isSeriesTypeOpen = !isSeriesTypeOpen; $event.stopPropagation()"
                        (keydown.space)="isSeriesTypeOpen = !isSeriesTypeOpen; $event.stopPropagation()">
                        <span [class.placeholder]="!selectedEventSeriesType">
                            {{ selectedEventSeriesType ? (selectedEventSeriesType.name | translate) : ('eventAssign.chooseFromList' | translate) }}
                        </span>
                    </div>
                    <ul class="app-c-select-list" *ngIf="isSeriesTypeOpen" role="listbox" aria-label="Series type list" (click)="$event.stopPropagation()">
                        <li *ngFor="let option of selectedEventType?.subType"
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="selectedEventSeriesType === option"
                            [class.is-selected]="selectedEventSeriesType === option"
                            (click)="selectedEventSeriesType = option; isSeriesTypeOpen = false"
                            (keydown.enter)="selectedEventSeriesType = option; isSeriesTypeOpen = false"
                            (keydown.space)="selectedEventSeriesType = option; isSeriesTypeOpen = false">
                            {{ option.name | translate }}
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>

        <!-- Select Specific Task – single select (no series) -->
        <ng-container *ngIf="selectedEventType?.subOptions?.length && !showSeriesType">
            <label class="required" translate>eventAssign.selectSpecificTask</label>

            <!-- Single -->
            <div class="custom-form-field" *ngIf="!selectedEventType.multiSelect">
                <div class="app-c-custom-select" [class.is-open]="isSingleTaskOpen">
                    <div class="app-c-select-trigger app-c-form-control"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="isSingleTaskOpen"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-label]="selectedEvent ? 'Selected task: ' + (selectedEvent.name | translate) : 'Select specific task'"
                        (click)="isSingleTaskOpen = !isSingleTaskOpen; $event.stopPropagation()"
                        (keydown.enter)="isSingleTaskOpen = !isSingleTaskOpen; $event.stopPropagation()"
                        (keydown.space)="isSingleTaskOpen = !isSingleTaskOpen; $event.stopPropagation()">
                        <span [class.placeholder]="!selectedEvent">
                            {{ selectedEvent ? (selectedEvent.name | translate) : ('eventAssign.chooseFromList' | translate) }}
                        </span>
                    </div>
                    <ul class="app-c-select-list" *ngIf="isSingleTaskOpen" role="listbox" aria-label="Specific task list" (click)="$event.stopPropagation()">
                        <ng-container *ngFor="let option of selectedEventType?.subOptions">
                            <li *ngIf="option.enabled"
                                role="option"
                                tabindex="0"
                                [attr.aria-selected]="selectedEvent === option"
                                [class.is-selected]="selectedEvent === option"
                                (click)="selectedEvent = option; isSingleTaskOpen = false"
                                (keydown.enter)="selectedEvent = option; isSingleTaskOpen = false"
                                (keydown.space)="selectedEvent = option; isSingleTaskOpen = false">
                                {{ option.name | translate }}
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <!-- Multi -->
            <div class="custom-form-field" *ngIf="selectedEventType.multiSelect">
                <div class="app-c-custom-select" [class.is-open]="dropdownOpenKey === 'noSeries'">
                    <div class="app-c-select-trigger app-c-form-control"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="dropdownOpenKey === 'noSeries'"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-label]="selectedEvent?.length ? 'Selected tasks: ' + getSelectedLabel(selectedEvent) : 'Select tasks'"
                        (click)="dropdownOpenKey = dropdownOpenKey === 'noSeries' ? null : 'noSeries'; $event.stopPropagation()"
                        (keydown.enter)="dropdownOpenKey = dropdownOpenKey === 'noSeries' ? null : 'noSeries'; $event.stopPropagation()"
                        (keydown.space)="dropdownOpenKey = dropdownOpenKey === 'noSeries' ? null : 'noSeries'; $event.stopPropagation()">
                        <span [class.placeholder]="!selectedEvent?.length">
                            {{ selectedEvent?.length ? getSelectedLabel(selectedEvent) : ('eventAssign.chooseFromList' | translate) }}
                        </span>
                    </div>
                    <ul class="app-c-select-list app-c-multiselect-list" *ngIf="dropdownOpenKey === 'noSeries'" role="listbox" aria-label="Task options" (click)="$event.stopPropagation()">
                        <li *ngFor="let option of selectedEventType?.subOptions">
                            <label class="multiselect-option">
                                <input type="checkbox" [checked]="isSelected(option)" (change)="toggleSelection(option)" />
                                <span>{{ option.name | translate }}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>

        <!-- Select Specific Task – with series -->
        <ng-container *ngIf="selectedEventSeriesType?.subOptions?.length && showSeriesType && selectedEventSeriesType">
            <label class="required" translate>eventAssign.selectSpecificTask</label>

            <!-- Video multi -->
            <div class="custom-form-field" *ngIf="selectedEventType.multiSelect && selectedEventSeriesType.key === 'video'">
                <div class="app-c-custom-select" [class.is-open]="dropdownOpenKey === 'seriesVideo'">
                    <div class="app-c-select-trigger app-c-form-control"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="dropdownOpenKey === 'seriesVideo'"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-label]="selectedEvent?.length ? 'Selected tasks: ' + getSelectedLabel(selectedEvent) : 'Select tasks'"
                        (click)="dropdownOpenKey = dropdownOpenKey === 'seriesVideo' ? null : 'seriesVideo'; $event.stopPropagation()"
                        (keydown.enter)="dropdownOpenKey = dropdownOpenKey === 'seriesVideo' ? null : 'seriesVideo'; $event.stopPropagation()"
                        (keydown.space)="dropdownOpenKey = dropdownOpenKey === 'seriesVideo' ? null : 'seriesVideo'; $event.stopPropagation()">
                        <span [class.placeholder]="!selectedEvent?.length">
                            {{ selectedEvent?.length ? getSelectedLabel(selectedEvent) : ('eventAssign.chooseFromList' | translate) }}
                        </span>
                    </div>
                    <ul class="app-c-select-list app-c-multiselect-list" *ngIf="dropdownOpenKey === 'seriesVideo'" role="listbox" aria-label="Video task options" (click)="$event.stopPropagation()">
                        <ng-container *ngFor="let option of selectedEventSeriesType?.subOptions">
                            <li *ngIf="option?.enabled">
                                <label class="multiselect-option">
                                    <input type="checkbox" [checked]="isSelected(option)" (change)="toggleSelection(option)" />
                                    <span>{{ option?.name }}</span>
                                </label>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <!-- Other multi -->
            <div class="custom-form-field" *ngIf="selectedEventType.multiSelect && selectedEventSeriesType.key !== 'video'">
                <div class="app-c-custom-select" [class.is-open]="dropdownOpenKey === 'seriesOther'">
                    <div class="app-c-select-trigger app-c-form-control"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="dropdownOpenKey === 'seriesOther'"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-label]="selectedEvent?.length ? 'Selected tasks: ' + getSelectedLabel(selectedEvent) : 'Select tasks'"
                        (click)="dropdownOpenKey = dropdownOpenKey === 'seriesOther' ? null : 'seriesOther'; $event.stopPropagation()"
                        (keydown.enter)="dropdownOpenKey = dropdownOpenKey === 'seriesOther' ? null : 'seriesOther'; $event.stopPropagation()"
                        (keydown.space)="dropdownOpenKey = dropdownOpenKey === 'seriesOther' ? null : 'seriesOther'; $event.stopPropagation()">
                        <span [class.placeholder]="!selectedEvent?.length">
                            {{ selectedEvent?.length ? getSelectedLabel(selectedEvent) : ('eventAssign.chooseFromList' | translate) }}
                        </span>
                    </div>
                    <ul class="app-c-select-list app-c-multiselect-list" *ngIf="dropdownOpenKey === 'seriesOther'" role="listbox" aria-label="Series task options" (click)="$event.stopPropagation()">
                        <li *ngFor="let option of selectedEventSeriesType?.subOptions">
                            <label class="multiselect-option">
                                <input type="checkbox" [checked]="isSelected(option)" (change)="toggleSelection(option)" />
                                <span>{{ option?.name }}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>

        <!-- Suggested Completion Date -->
        <label class="required" translate>eventAssign.SuggestedCompletionDate</label>
        <div class="app-c-datepicker app-c-form-group">
            <input class="app-c-form-control"
                [owlDateTime]="dt1"
                [owlDateTimeTrigger]="dt1"
                placeholder="Select Date"
                [(ngModel)]="selectedDate"
                [min]="minDate"
                aria-label="Suggested completion date"
                aria-required="true" />
            <div class="app-c-datepicker__icon">
                <svg-icon icon="calendar" aria-hidden="true"></svg-icon>
            </div>
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>

    </div>

    <div class="footer-popup">
        <button type="button" tabindex="0" class="app-c-btn app-c-btn--secondary"
            (click)="cancel()" (keypress)="cancel()" aria-label="Close dialog">
            <span translate>blocked.close</span>
        </button>
        <button type="button" class="app-c-btn app-c-btn--primary" tabindex="0"
            [disabled]="!selectedUser || !selectedEventType ||
                (selectedEventType?.type === 'series'
                    ? (!selectedEventSeriesType || !selectedEvent)
                    : (selectedEventType?.subOptions && !selectedEvent)
                ) || isLoading"
            (click)="onSubmit()" (keypress)="onSubmit()" aria-label="Assign selected event">
            <span translate>eventAssign.assign</span>
            <mat-spinner *ngIf="isLoading" aria-hidden="true"></mat-spinner>
        </button>
    </div>
</div>
<span class="app-l-mc__overlay" role="button" tabindex="0" aria-label="Close assign dialog" (click)="cancel()" (keypress)="cancel()" (keydown.enter)="cancel()" (keydown.space)="cancel()"></span>